// Used in many components

import {
    Component,
    ChangeDetectionStrategy,
    Input,
    OnInit,
} from "@angular/core";

@Component({
    selector: "profile-image",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./profile-image.component.html",
    styleUrls: ["./profile-image.component.scss"],
    standalone: false
})
export class ProfileImageComponent implements OnInit {
    profileImageClass = "";
    @Input() profileUrl = "/assets/images/thumbnailDefault.png";
    @Input() imgSize = "";
    @Input() altText = "";
    @Input() radiusType = "circle";
    @Input() title = "";

    constructor() {}

    ngOnInit() {
        this.profileImageClass = "profile-image-" + this.radiusType;
        if (this.imgSize === "small") {
            this.profileImageClass = this.profileImageClass + " clip-circle-sm";
        }
    }
}
